import React, {useState, useEffect} from 'react';
import {Modal, Button} from 'react-bootstrap'
import FormGroup from 'live/components/forms/ui/form-group'
import { createCompany, updateCompany } from '../api/companyApi';
import i18n from 'live/services/i18n';
import SubmitOrCancel from 'live/components/forms/ui/submit-or-cancel';
import styled from 'styled-components';
import './../../assets/scss/form.scss';

const CreateCompanyModal = ({showModal, closeModal, company}) => {
    
    const [show, setShow] = useState();
    const [companyLocal, setCompanyLocal] = useState(company || {});
    const [hasName, setHasName] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [messageErrorResponseApi, setMessageErrorResponseApi] = useState();
  
    useEffect(() => {
        setShow(showModal);
    }, [showModal])

    const handleCompanyName = (event) => {
        setCompanyLocal({...companyLocal, ...{ 'name': event.target.value }});
        setHasName(true);
    }

    const save = (newCompany) => {
      setIsSaving(true);
      
      if(isValidFields(newCompany)){
        
        if(newCompany.id){
          updateDB(newCompany);
        }
        else{
          saveDB(newCompany);
        }
      }
    }

    const saveDB = (newCompany) => {
      createCompany(newCompany)
      .then(response => {    
          closeModal()                
      })
      .catch(error => {
        setMessageErrorResponseApi(error?.response?.data?.message || error?.response?.data);
      })
      .finally(() => {
        setIsSaving(false);
      })
      ;
    }

    const updateDB = (newCompany) => {
      updateCompany(newCompany)
      .then(response => {  
          closeModal()                
      })
      .catch(error => {
        setMessageErrorResponseApi(error?.response?.data?.message || error?.response?.data);
      })
      .finally(() => {
        setIsSaving(false);
      })
      ;
    }

    const isValidFields = (company) =>{      
      setHasName(true);

      if(company.name == null || company.name === ''){
        setHasName(false);
        return false;
      }

      return true;
    }
  
    return (
      <> 
        <Modal show={show} onHide={closeModal}>
          <Modal.Header closeButton>
              
            <Modal.Title>Create company</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          
              <FormGroup 
                    className={!hasName ? 'custom-form-group-danger' : ''}
                    type="text" 
                    disabled={false}
                    label="Company Name" 
                    value={companyLocal.name ? companyLocal.name : ""} 
                    onChange={handleCompanyName} 
                    help={hasName ? '' : i18n("Company Name can't be empty")}
                    />

            <div class="custom-form-group-danger">
              <span class="custom-form-group-danger help-block">{messageErrorResponseApi}</span>
            </div>

          </Modal.Body>
          <Modal.Footer>
            <SubmitOrCancel
                    disabled={hasName == false}
                    saving={isSaving}
                    onSubmit={() => save(companyLocal)}
                    onCancel={closeModal}
            />
          </Modal.Footer>
        </Modal>
      </>
    );
  }
  
  export default CreateCompanyModal;

